const orderStates = ["editing", "validated"];

export default orderStates;
